import { CriticalOrganizationUpdatesTabs } from 'src/components/critical-organization-updates/tabs';
import FooterPrivacy from 'src/views/auth/components/baseTemplate/FooterPrivacy';
import React from 'react';
import { useTranslation } from 'react-i18next';

import 'src/components/critical-organization-updates/styles.scss';

const ViewCriticalOrganizationUpdates: React.FC = () => {
    const { t } = useTranslation();

    return (
        <>
            <main className='critical-updates'>
                <div className='page-title'>
                    <h1>
                        {t(
                            'SystemAdmin.CriticalOrganizationUpdates.PageTitle',
                            {
                                defaultValue: 'Critical Organization Updates',
                            },
                        )}
                    </h1>
                </div>
                <CriticalOrganizationUpdatesTabs active='update' />
                <section className='c-form-section critical-updates__card' />
            </main>
            <div className='critical-updates__privacy-footer'>
                <FooterPrivacy />
            </div>
        </>
    );
};

export default ViewCriticalOrganizationUpdates;
